function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWaves2 = function SvgWaves2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 98.9",
    style: {
      enableBackground: "new 0 0 1440 98.9"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m0 59 6.2 3.3C12.3 65.5 25 72.2 37 75.4c12.2 3.3 25 3.3 37-4.9 12.2-8.1 24-24.7 37-27.8 12.1-3.3 24 6.5 37 9.8 12 3.2 24 .1 37 6.5 11.9 6.5 24 23 37 21.3 11.8-1.6 24-21.3 36-29.5 12.8-8.1 25-5 37 4.9 12.7 9.7 25 26.3 37 32.8 12.6 6.5 25 3.4 37-6.5 12.5-9.7 25-26.3 37-37.7 12.5-11.4 25-18.1 37-21.3 12.4-3.3 25-3.3 37 0 12.3 3.2 25 9.9 37 11.5 12.2 1.5 25-1.5 37 3.3 12.2 5 24 17.9 37 27.8 12.1 9.7 24 16.5 37 19.7 12 3.3 24 3.3 37-6.5 11.9-9.8 24-29.5 37-31.1 11.8-1.8 24 14.8 36 26.2C750.8 85.3 763 92 775 87c12.7-4.8 25-21.4 37-32.8 12.6-11.4 25-18.1 37-16.4 12.5 1.6 25 11.5 37 11.5 12.5 0 25-9.8 37-18 12.4-8.1 25-14.8 37-8.2 12.3 6.5 25 26.2 37 41 12.2 14.7 25 24.6 37 18 12.2-6.7 24-29.4 37-37.7 12.1-8.3 24-1.5 37 3.3 12 5 24 8.1 37 8.2 11.9-.1 24-3.2 37-8.2 11.8-4.8 24-11.6 36-19.7 12.8-8.2 25-18 37-11.5 12.7 6.7 25 29.4 37 34.4 12.6 4.8 25-8.1 37-9.8 12.5-1.6 25 8.2 37 14.7 12.5 6.7 25 9.7 37 11.5 12.4 1.6 25 1.6 31 1.6h6V0H0v59z",
    style: {
      fill: "#333"
    }
  }));
};

export default SvgWaves2;